
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import WhyChoose from './components/WhyChoose';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-50 font-['Noto_Sans_KR']">
      <Header />
      <Hero />
      <Products />
      <WhyChoose />
      <Contact />
      <Footer />
    </div>
  );
}